<template>
  <div>
    <div v-if="!showField">
      <el-row>
        <div align="right">
          <showButtonPdf :type="3" label="Descargar Justificación 2020"/>
        </div>
      </el-row>
      <el-form-item label="1. Nombre completo del bien o servicio a contratar.">
        <label style="margin-left: 40px">
          Nombre del Servicio: <b>{{ filterServiceName(requestForm.service_name_id) }}</b>
          <br>
          Tipo de Solicitud: <b>{{ requestForm.type && requestForm.type.name ? requestForm.type.name : '' }}</b>
        </label>
      </el-form-item>
      <el-form-item v-if="!(selectedProv || providerActive)">
        <el-tag>
          Por favor; seleccione un proveedor antes de continuar.
        </el-tag>
      </el-form-item>
      <el-form-item
          label="">

        <label class="el-form-item__label">
          <span style="color: #D75452;margin-right: 4px;">*</span>Nombre del proveedor Seleccionado:
        </label>
        <el-select
            style="width:100%"
            clearable
            :disabled="onlyRead== true ? true: false"
            v-model="providerActive"
            @change="selectedProviderAux(providerActive)"
            filterable
            placeholder="Seleccionar">
          <el-option
              v-for="(item,key) in filterId(requestForm.providers)"
              :key="key"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <span v-if="selectedProv || providerActive">
                <el-form-item label="2.	Antecedentes del bien o servicio a contratar"
                              :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
                              prop="background">
                  <el-tooltip placement="top">
                  <div slot="content" style="font-size: 12pt">
                    {{ descriptions.background }}
                  </div>
                    <i style="font-size: 13px" class="fas fa-info"/>
                  </el-tooltip>
                  <el-button
                      type="text"
                      style="font-size: 13px"
                      v-clipboard:copy="requestForm.background"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                  >
            Copiar <i class="fas fa-copy"/>
          </el-button>
                  <el-button
                      type="text"
                      v-if="infoUser.profile == 1"
                      @click="showModalDescription(descriptions.background, 'background')"
                      style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
                  <editor
                      :init='init'
                      id="background"
                      v-model="requestForm.background"
                      :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                      placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado"
                  >
                </editor>
            </el-form-item>
            <el-form-item label="3.	Análisis de la situación actual"
                          :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
                          prop="analysis">
               <el-tooltip placement="top">
                  <div slot="content" style="font-size: 12pt">
                    {{ descriptions.analysis }}
                  </div>
                    <i style="font-size: 13px" class="fas fa-info"/>
                  </el-tooltip>
              <el-button
                  type="text"
                  style="font-size: 13px"
                  v-clipboard:copy="requestForm.analysis"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
              >
            Copiar <i class="fas fa-copy"/>
          </el-button>
              <el-button
                  type="text"
                  v-if="infoUser.profile == 1"
                  @click="showModalDescription(descriptions.analysis, 'analysis')"
                  style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
              <editor
                  :init='init'
                  id="analysis_1"
                  v-model="requestForm.analysis"
                  :disabled="true"
                  placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado"
              >
                </editor>
            </el-form-item>
            <el-form-item label="4.	Objetivos esperados del proyecto"
                          :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
                          prop="expectedGoals">
              <el-tooltip placement="top">
                  <div slot="content" style="font-size: 12pt">
                    {{ descriptions.expectedGoals }}
                  </div>
                    <i style="font-size: 13px" class="fas fa-info"/>
                  </el-tooltip>
              <el-button
                  type="text"
                  style="font-size: 13px"
                  v-clipboard:copy="requestForm.expectedGoals"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
              >
            Copiar <i class="fas fa-copy"/>
          </el-button>
              <el-button
                  type="text"
                  v-if="infoUser.profile == 1"
                  @click="showModalDescription(descriptions.expectedGoals, 'expectedGoals')"
                  style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
              <editor
                  id="expectedGoals"
                  :init='init'
                  v-model="requestForm.expectedGoals"
                  :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                  placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
                </editor>
            </el-form-item>
            <el-form-item
                label="5.	Beneficios esperados del proyecto y estrategias (líneas de acción) para lograrlo. "
                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
                prop="expectedBenefits">
               <el-tooltip placement="top">
                  <div slot="content" style="font-size: 12pt">
                    {{ descriptions.expectedBenefits }}
                  </div>
                    <i style="font-size: 13px" class="fas fa-info"/>
                  </el-tooltip>
              <el-button
                  type="text"
                  style="font-size: 13px"
                  v-clipboard:copy="requestForm.expectedBenefits"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
              >
            Copiar <i class="fas fa-copy"/>
          </el-button>
              <el-button
                  type="text"
                  v-if="infoUser.profile == 1"
                  @click="showModalDescription(descriptions.expectedBenefits, 'expectedBenefits')"
                  style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
              <editor
                  id="expectedBenefits"
                  :init="init"
                  v-model="requestForm.expectedBenefits"
                  :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                  placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">
                </editor>
            </el-form-item>
            <el-form-item label="6.	Riesgos identificados asociados al proyecto."
                          :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
                          prop="expectedRisks">
               <el-tooltip placement="top">
                  <div slot="content" style="font-size: 12pt">
                    {{ descriptions.expectedRisks }}
                  </div>
                    <i style="font-size: 13px" class="fas fa-info"/>
                  </el-tooltip>
              <el-button
                  type="text"
                  style="font-size: 13px"
                  v-clipboard:copy="requestForm.expectedRisks"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
              >
            Copiar <i class="fas fa-copy"/>
          </el-button>
              <el-button
                  type="text"
                  v-if="infoUser.profile == 1"
                  @click="showModalDescription(descriptions.expectedRisks, 'expectedRisks')"
                  style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
              <editor
                  id="expectedRisks"
                  :init="init"
                  v-model="requestForm.expectedRisks"
                  :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                  placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">

                </editor>
            </el-form-item>
            <el-form-item label="7.	Impacto operativo en caso de no aprobarse el proyecto"
                          :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }"
                          prop="operationalImpact">
               <el-tooltip placement="top">
                  <div slot="content" style="font-size: 12pt">
                    {{ descriptions.operationalImpact }}
                  </div>
                    <i style="font-size: 13px" class="fas fa-info"/>
                  </el-tooltip>
              <el-button
                  type="text"
                  style="font-size: 13px"
                  v-clipboard:copy="requestForm.operationalImpact"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
              >
            Copiar <i class="fas fa-copy"/>
          </el-button>
              <el-button
                  type="text"
                  v-if="infoUser.profile == 1"
                  @click="showModalDescription(descriptions.operationalImpact, 'operationalImpact')"
                  style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
              <editor
                  id="operationalImpact"
                  :init="init"
                  v-model="requestForm.operationalImpact"
                  :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                  placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">

                </editor>
            </el-form-item>
            <el-form-item label="8.	Justificación del proveedor seleccionado con base en Art. 16 de la Ley
                de Adquisiciones, Arrendamientos y Servicios del Sector Público">
                <label>Describir las consecuencias y repercusiones en la operación de la Representación,
                    en caso de que no se apruebe el proyecto.</label>
                <Economic :providerActive="providerActive"/>
            </el-form-item>
            <br>
            <div class="custom-label-body">
                9. Manifiesto de que se realizó la investigación de mercado.
                <el-tag size="mini">
                    {{
                    requestForm.office ? requestForm.office.type.name :
                        ''
                  }} de México en
                    {{
                     requestForm.office ? requestForm.office.location :
                        ''
                  }}
                </el-tag>
                manifiesta haber solicitado las cotizaciones en igualdad de condiciones para todos los proveedores
                convocados y cuenta con las cotizaciones originales recabadas en el expediente respectivo de la
                contratación para efectos de cualquier revisión posterior por parte de los órganos fiscalizadores.

                En caso de no contar con 3 cotizaciones, deberá adjuntar prueba documental que permita dar sustento
                a la investigación de mercado, así como justificar de conformidad con lo establecido en el
                numeral 6.3.2.1.9 de las POBALINES vigentes; o, en su caso, citar la circular para Representaciones
                de vida Difícil emitida por la DGSERH

                <el-tag size="mini"> DSE-DG-01675</el-tag>
            </div>
            <br>
            <el-form-item
                label="10. Suficiencia presupuestaria"
                prop="provider_selected.budgetSufficiency"
                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
              <el-tooltip placement="top">
                  <div slot="content" style="font-size: 12pt">
                    {{ descriptions.budgetSufficiency }}
                  </div>
                    <i style="font-size: 13px" class="fas fa-info"/>
                  </el-tooltip>
              <el-button
                  type="text"
                  style="font-size: 13px"
                  v-clipboard:copy="requestForm.provider_selected.budgetSufficiency"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
              >
            Copiar <i class="fas fa-copy"/>
          </el-button>
              <el-button
                  type="text"
                  v-if="infoUser.profile == 1"
                  @click="showModalDescription(descriptions.budgetSufficiency, 'budgetSufficiency')"
                  style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
              <editor
                  id="budgetSufficiency"
                  :init="init"
                  v-model="requestForm.provider_selected.budgetSufficiency"
                  :disabled="providerActive == '' ||  onlyRead== true ? true: false"
                  placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">

                </editor>
            </el-form-item>
            <el-form-item
                label="11. Conclusión"
                prop="provider_selected.conclusion"
                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">
              <el-tooltip placement="top">
                  <div slot="content" style="font-size: 12pt">
                    {{ descriptions.conclusion }}
                  </div>
                    <i style="font-size: 13px" class="fas fa-info"/>
                  </el-tooltip>
              <el-button
                  type="text"
                  style="font-size: 13px"
                  v-clipboard:copy="requestForm.provider_selected.conclusion"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
              >
            Copiar <i class="fas fa-copy"/>
          </el-button>
              <el-button
                  type="text"
                  v-if="infoUser.profile == 1"
                  @click="showModalDescription(descriptions.conclusion, 'conclusion')"
                  style="font-size: 13px">
        Actualizar Marca de agua <i class="fas fa-align-justify"></i>
      </el-button>
              <editor
                  id="conclusion32"
                  :init="init"
                  v-model="requestForm.provider_selected.conclusion"
                  :disabled="true"
                  placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado">

                </editor>
            </el-form-item>
            <br>
            <Docs :onlyRead="onlyRead" :sectionId="5">
                <div slot="main">
                    Suba su documento firmado de "Justificación 2020"
                </div>
            </Docs>
            </span>
      <div align="right">
        <showButtonPdf :type="3" label="Descargar Justificación 2020"/>
      </div>
      <el-dialog
          :fullscreen="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          title="Redacción sugerida"
          :visible.sync="modalDescription">
        <el-form
            @submit.native.prevent>
          <el-row>
            <el-col>
              <el-input
                  type="textarea"
                  :rows="10"
                  v-model="modelDescription.text"/>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button @click="saveDescription()">
          Guardar
        </el-button>
        <el-button @click="modelDescription.text = ''; modalDescription = false">
          cerrar
        </el-button>
      </span>
      </el-dialog>


    </div>
  </div>

</template>

<script>

import {mapState, mapGetters, mapActions, mapMutations} from "vuex";
import Label from "@/components/views/acquisition/partials/Label";
import Economic from "@/components/views/acquisition/partials/Economic";
import Payments from "@/components/views/acquisition/partials/Payments";
import showButtonPdf from '@/components/views/acquisition/partials/showButtonPdf'
import Docs from '@/components/views/acquisition/partials/Docs'
import PreviousSuppliers from '@/components/views/acquisition/partials/PreviousSuppliers'
import {Notification} from "element-ui";


export default {

  props: {
    showField: {type: Boolean}
  },

  components: {
    Docs,
    Label,
    Economic,
    Payments,
    showButtonPdf,
    PreviousSuppliers,
  },
  computed: {
    ...mapGetters("form", {
      requestForm: "requestForm",
      catalogs: "catalogs",
      general: "general",
      onlyRead: "onlyRead",
      providerActive2: "providerActive",
      optionEditor: "optionEditor",
      descriptions: "descriptionsAreas"
    }),
    infoUser() {
      return this.$store.state.user
    },
    providerActive: {
      get() {
        return this.providerActive2;
      },
      set(newValue) {
        return this.$store.dispatch('form/setProviderActive2', newValue, {root: true});
      }
    },


    tableData() {
      return []
    },

  },

  data() {
    return {
      selectedProv: false,
      loading: false,
      modelDescription: {},
      modalDescription: false,
      init: {
        language_url: '/tinymce/langs/es_419.js',
        language: 'es_419',
        skin_url: 'tinymce/skins/ui/oxide',
        // skin_url: 'tinymce/skins/ui/oxide-dark', // color oscuro
        height: 350,
        // inline: true,
        menubar: false,
        toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | ' +
            'bullist numlist outdent indent | link image | print preview media fullscreen',
        content_style: 'body { font-family:Montserrat; font-size:12px }'
      },
    }
  },

  methods: {
    ...mapMutations('form', {
      selectedProvider: "selectedProvider",
      setProviderSelected: "setProviderSelected",
      setValue: "setValue",
      setCheckAgreementId: 'setCheckAgreementId',
    }),
    ...mapActions('form', {
      fetchDescriptions: "fetchDescriptions"
    }),
    filterId(data) {
      data = data.filter(item => item.name);
      return data;
    },

    selectedProviderAux(providerActive) {
      if (providerActive) {
        this.selectedProvider(providerActive);
        this.requestForm.provider_selected.conclusion = 'Por lo antes expuesto y de conformidad con el artículo 16 de la Ley de Adquisiciones, Arrendamientos y Servicios del Sector Público (LAASSP), el Titular de la Representación declara bajo protesta de decir verdad que la información remitida en el presente documento es veraz y se apega a lo señalado en el DECRETO por el que se modifica el diverso que establece las medidas para el uso eficiente, transparente y eficaz de los recursos públicos, y las acciones de disciplina presupuestaria en el ejercicio del gasto público, así como la modernización de la Administración Pública Federal. Por lo anterior, solicita se dictamine sobre la procedencia de realizar la contratación citada en el presente documento.';
      }
    },
    filterServiceName(serviceId) {
      let name = this.catalogs.serviceName.filter(up => up.id == serviceId);
      name = _.head(name);
      return name = name && name.name ? name.name : 'No se ha seleccionado bien o servicio';
    },

    subTotal(data) {
      if (data) {
        let _a = parseFloat(data.monthlyCostWithTaxes);
        let _b = parseFloat(data.monthlyAgreementValidity);

        let subTotal = _a * _b;

        if (isNaN(subTotal) || subTotal == '' || !subTotal) return 0;

        try {
          return subTotal.toFixed(2);
        } catch (err) {
          return subTotal;
        }
      }

    },

    total(data) {
      if (data) {
        let _a = parseFloat(data.monthlyCostWithTaxes);
        let _b = parseFloat(data.monthlyAgreementValidity);
        let _c = parseFloat(data.instalmentCosts);
        let _d = parseFloat(data.anotherExpenses);

        let subTotal = (_a * _b) + _c + _d;

        if (isNaN(subTotal) || subTotal == '' || !subTotal) return 0;

        try {
          return subTotal.toFixed(2);
        } catch (err) {
          return subTotal;
        }
      }
    },

    absoluteValue(operator1, operator2) {
      let substrac = operator1 - operator2;

      if (substrac < 0) {
        substrac = substrac * -1;
      }
      return substrac
    },

    sumaX(item2, column) {
      if (column == 1) {
        let _a = parseFloat(item2.acquisitionPriceGoods);
        let _b = parseFloat(item2.acquisitionInstallationCosts);
        let _c = parseFloat(item2.acquisitionTransportationExpenses);
        let _d = parseFloat(item2.acquisitionOtherExpenses);
        let suma = _a + _b + _c + _d;
        if (isNaN(suma) || suma == '' || !suma) return 0;
        try {
          return suma.toFixed(2);
        } catch (err) {
          return suma;
        }
      }
      if (column == 2) {
        let _a = parseFloat(item2.leasingMonthlyPriceGoods);
        let _b = parseFloat(item2.leasingMonthlyInstallationCosts);
        let _c = parseFloat(item2.leasingMonthlyTransportationExpenses);
        let _d = parseFloat(item2.leasingMonthlyOtherExpenses);
        let suma = _a + _b + _c + _d;
        if (isNaN(suma) || suma == '' || !suma) return 0;
        try {
          return suma.toFixed(2);
        } catch (err) {
          return suma;
        }
      }
      if (column == 3) {
        let _a = parseFloat(item2.leasingMonthsPriceGoods);
        let _b = parseFloat(item2.leasingMonthsInstallationCosts);
        let _c = parseFloat(item2.leasingMonthsTransportationExpenses);
        let _d = parseFloat(item2.leasingMonthsOtherExpenses);
        let suma = _a + _b + _c + _d;
        if (isNaN(suma) || suma == '' || !suma) return 0;
        try {
          return suma.toFixed(0);
        } catch (err) {
          return suma;
        }
      }
      if (column == 4) {
        let _a = parseFloat(item2.leasingAnnualPriceGoods);
        let _b = parseFloat(item2.leasingAnnualInstallationCosts);
        let _c = parseFloat(item2.leasingAnnualTransportationExpenses);
        let _d = parseFloat(item2.leasingAnnualOtherExpenses);
        let suma = _a + _b + _c + _d;
        if (isNaN(suma) || suma == '' || !suma) return 0;
        try {
          return suma.toFixed(2);
        } catch (err) {
          return suma;
        }
      }
    },

    parseDate(date) {

      if (date != '') return moment(date).format('D/M/Y')
    },
    sumaAlias(data1, data2, variable) {

      let suma = data1 * data2;
      this.setValue({suma: suma, variable: variable});

      return suma;
    },
    async onCopy(e) {
      try {
        await this.$copyText(e.text.replace(/(<([^>]+)>)/ig, '')).then(async function (ee) {
          Notification.success('Se copió el texto correctamente.')
        }, function (e) {
          console.log(e)
        })
      } catch (e) {
        console.log("copy clipboard ", e)
      }
    },
    onError: function (e) {
      alert('Failed to copy the text to the clipboard')
      console.log(e);
    },
    showModalDescription(text, model) {
      let _object = {
        text: text,
        model: model
      }
      this.modelDescription = Object.assign({}, _object);
      this.modalDescription = true;
    },
    saveDescription() {
      axios.post('/api/acquisitions/s-description', {
        description: this.modelDescription
      }).then(response => {
        if (response.data.success) {
          Notification.success(response.data.message);
          this.modalDescription = false;
          this.fetchDescriptions();
        } else {
          Notification.error(response.data.message)
        }
      }).catch(e => {
        console.log("error ", e);
        Notification.error('No se pudo procesar su solicitud.')
      })
    }
  },
  watch: {
    'requestForm.provider_selected': {
      handler(after, before) {
        this.setProviderSelected(this.requestForm.provider_selected);
        this.requestForm.provider_selected.conclusion = 'Por lo antes expuesto y de conformidad con el artículo 16 de la Ley de Adquisiciones, Arrendamientos y Servicios del Sector Público (LAASSP), el Titular de la Representación declara bajo protesta de decir verdad que la información remitida en el presente documento es veraz y se apega a lo señalado en el DECRETO por el que se modifica el diverso que establece las medidas para el uso eficiente, transparente y eficaz de los recursos públicos, y las acciones de disciplina presupuestaria en el ejercicio del gasto público, así como la modernización de la Administración Pública Federal. Por lo anterior, solicita se dictamine sobre la procedencia de realizar la contratación citada en el presente documento.';
      },
      deep: true
    }
  },
}
</script>

<style scoped>
.border-red {
  border-right: 5px solid #ab0d48;
}
</style>